import React, { useState } from "react";
import TitleUnderlined from "../../components/TitleUnderlined";
import Divider from "../../components/Divider";
import Row from "../../components/Row";
import Column from "../../components/Column";
import SpinnerButton from "../../components/SpinnerButton";
import Button from "../../components/Button";
import Form from "../../components/Form";

const EditEventView = () => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <div className="pt-5 pb-5">
            <Form 
            submitCallback={(success) => {
                // navigate('/registrar-grupo/gracias');
            }}
            isLoadingCallback={(isLoading) => {
                setIsLoading(isLoading);
            }}>
                <TitleUnderlined>Registro de <span className="embercom_overlined">Evento</span></TitleUnderlined>
                <br />
                <br />
                <br />
                <h5 className="text-uppercase"><b>Nuevo registro</b></h5>
                <Divider style={{maxWidth: '350px', height: '2px'}} />
                <p className="mt-2 mb-0 semibold">Indicar el número de boletos disponibles para el evento:</p>
                <SpinnerButton className="mb-4" style={{maxWidth: '200px'}} onChange={(res) => {
                    console.log('todo...');
                }} />
                <br />
                <br />
                <Row>
                    <Column className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="title" className="semibold">Título</label>
                            <input className="form-control" required type="text" name="title" id="title" />
                        </div>
                    </Column>
                    <Column className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="description" className="semibold">Descripción</label>
                            <textarea className="form-control" name="description" id="description"></textarea>
                        </div>
                    </Column>
                    <Column className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="location" className="semibold">Ubicación</label>
                            <input className="form-control" required type="text" name="location" id="location" />
                        </div>
                    </Column>
                    <Column className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="start_date" className="semibold">Fecha inicio</label>
                            <input className="form-control" required type="text" name="start_date" id="start_date" />
                        </div>
                    </Column>
                    <Column className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="end_date" className="semibold">Fecha fin</label>
                            <input className="form-control" required type="text" name="end_date" id="end_date" />
                        </div>
                    </Column>
                    <Column className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="price" className="semibold">Precio</label>
                            <input className="form-control" required type="text" name="price" id="price" />
                        </div>
                    </Column>
                </Row>
                <br />
                <Button>
                    {isLoading ? <><span className="spinner-border spinner-border-sm mr-4" style={{marginRight: '1rem'}} role="status" aria-hidden="true"></span>Enviando...</> : 
                        <>Guardar cambios <img src={require('../../assets/arrow_next.png')} alt="arrowNext" /></>
                    }
                    
                </Button>
            </Form>
        </div>
    )
}

export default EditEventView;